<!-- 巡检计划 -->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery1">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('计划名称')">
              <j-input :placeholder="$t('请输入计划名称')" v-model="queryParam.planName"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('计划类型')">
              <j-dict-select-tag v-model="queryParam.planType" :placeholder="$t('请选择计划类型')" dictCode="plan_type" style="width:100%"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('计划类别')">
              <a-select :placeholder="$t('请选择计划类别')" v-model="queryParam.planCategory">
                <a-select-option :value="0">{{ $t('重点区域') }}</a-select-option>
                <a-select-option :value="1">{{ $t('查漏专项') }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery1" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset1" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('新增') }}</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('tickets')">{{ $t('导出') }}</a-button> -->
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">{{ $t('导入') }}</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>{{ $t('删除') }}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">{{ $t('清空') }}</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :customRow="customRow"
        :loading="loading"
        :rowSelection="{type:'radio', selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap "
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text,record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无图片') }}</span>
          <img v-else :src="getImgView(text)" :preview="record.id" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">{{ $t('无文件') }}</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>
        <template slot="planState"  slot-scope="text, record">
          <a-tag v-if="record.planState == 1">{{ $t('未启用') }}</a-tag>
          <a-tag color="blue" v-if="record.planState == 0">{{ $t('已启用') }}</a-tag>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click.stop="handleEdit(record)" :disabled="record.planState==0">{{ $t('编辑') }}</a>
          <a-divider type="vertical" />
          <a-popconfirm :title="record.planState == 0 ? $t('确定停用吗?') : $t('确定启用吗?')" @confirm.stop="() => handleStartOrStop(record)">
            <a>{{record.planState == 0 ? $t('停用') : $t('启用')}}</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{ $t('更多') }} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click.stop="handleDetail(record)">{{ $t('详情') }}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('确定删除吗?')" @confirm.stop="() => handleDelete1(record.id)">
                  <a>{{ $t('删除') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <div style="margin-top: 50px;" v-if="dataSource1.length>0">
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns1"
        :dataSource="dataSource1"
        :loading="loading"
        :pagination="false"
        class="j-table-force-nowrap "
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail1(record)">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>
    <inspectionPlanModal ref="modalForm" @ok="loadData"></inspectionPlanModal>
    <inspectionPlanDetailModal ref="detailForm" @ok="loadData"></inspectionPlanDetailModal>
    <deviceModal ref="deviceForm"></deviceModal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JInput from '@/components/jeecg/JInput'
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  import inspectionPlanModal from './modules/inspectionPlanModal'
  import inspectionPlanDetailModal from './modules/inspectionPlanDetailModal'
  import deviceModal from '../deviceManagement/modules/deviceModal'

  export default {
    name: 'inspectionPlanIndexList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JInput,
      inspectionPlanModal,
      inspectionPlanDetailModal,
      deviceModal
    },
    data () {
      return {
        url: {
          list: "/jeecg-engineering/inspection/inspectionPlan/list",
          delete: "/jeecg-engineering/inspection/inspectionPlan/delete",
          deleteBatch: "/jeecg-engineering/inspection/inspectionPlan/deleteBatch",
          exportXlsUrl: "/jeecg-engineering/ticket/tickets/exportXls",
          importExcelUrl: "jeecg-engineering/ticket/tickets/importExcel",
          edit: "/jeecg-engineering/inspection/inspectionPlan/edit",
          queryById: "/jeecg-engineering/inspection/inspectionPlan/queryById",
          queryTableById: "/jeecg-engineering/inspection/inspectionPlan/queryTableById"
        },
        dictOptions:{},
        superFieldList:[],
        dataSource1:[],
        queryParam:{
          source: 1
        }
      }
    },
    created() {},
    computed: {
      description() {
        return this.$t('巡检计划页面')
      },
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('计划类型'),
            align:"center",
            dataIndex: 'planType',
            customRender: (t,r,indnx) => {
              return filterDictTextByCache('plan_type',t)
            }
          },
          {
            title: this.$t('计划名称'),
            align:"center",
            dataIndex: 'planName'
          },
          {
            title: this.$t('计划类别'),
            align:"center",
            dataIndex: 'planCategory',
            customRender: (t,r,index) => {
              if(t == 0){
                return this.$t('重点区域');
              }else if(t == 1){
                return this.$t('查漏专项');
              }
            }
          },
          {
            title: this.$t('区域'),
            align:"center",
            dataIndex: 'planArea'
          },
          {
            title: this.$t('计划周期'),
            align:"center",
            dataIndex: 'customCycleType',
            customRender: (t,r,index) => {
              return r.customCycleValue+' '+filterDictTextByCache('customCycleType',t)
            }
          },
          {
            title: this.$t('测点实体'),
            align:"center",
            dataIndex: 'planEntitiy',
            customRender: (t,r,index) => {
              return filterDictTextByCache('planEntitiy',t)
            }
          },
          {
            title: this.$t('巡检方式'),
            align:"center",
            dataIndex: 'planManner',
            customRender: (t,r,index) => {
              if(t == 0){
                return this.$t('步巡');
              }else if(t == 1){
                return this.$t('车巡');
              }
            }
          },
          {
            title: this.$t('计划状态'),
            align:"center",
            dataIndex: 'planState',
            scopedSlots: { customRender: 'planState' }
          },
          {
            title: this.$t('创建人'),
            align:"center",
            dataIndex: 'createBy'
          },
          {
            title: this.$t('创建时间'),
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title: this.$t('更新时间'),
            align:"center",
            dataIndex: 'updateTime'
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            width:160,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
      columns1() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('路线名称'),
            align:"center",
            dataIndex: 'routeName',
            ellipsis: true,
          },
          {
            title: this.$t('设备编号'),
            align:"center",
            dataIndex: 'deviceNum',
            ellipsis: true,
          },
          {
            title: this.$t('设备类型'),
            align:"center",
            dataIndex: 'deviceType',
            customRender: (text) => {
              return filterDictTextByCache('deviceType', text)
            },
            ellipsis: true,
          },
          {
            title: this.$t('设备名称'),
            align:"center",
            dataIndex: 'deviceName',
            ellipsis: true,
          },
          {
            title: this.$t('设备经度'),
            align:"center",
            dataIndex: 'detectLongitude',
            ellipsis: true,
          },
          {
            title: this.$t('设备纬度'),
            align:"center",
            dataIndex: 'detectLatitude',
            ellipsis: true,
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            width:150,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      searchQuery1(){
        this.selectedRowKeys = [];
        this.dataSource1 = [];
        this.searchQuery()
      },
      searchReset1(){
        this.selectedRowKeys = [];
        this.dataSource1 = [];
        this.searchReset()
      },
      searchReset(){
        this.queryParam = {
          source: 1,
        };
        this.loadData(1);
      },
      handleDelete1(id){
        this.selectedRowKeys = [];
        this.dataSource1 = [];
        this.handleDelete(id)
      },
      // 详情
      handleDetail(row){
        this.$nextTick(()=>{
          this.$refs.detailForm.init(row);
        })
      },
      handleStartOrStop(row){
        let params = JSON.parse(JSON.stringify(row));
        let message = '';
        if(params.planState == 0){
          params.planState = 1;
          message = this.$t('停用成功');
        }else{
          params.planState = 0;
          message = this.$t('启用成功');
        }
        this.loading = true;
        getAction(this.url.queryById,{id:row.id}).then(res=>{
          if(res.success){
            let routeIds = [];
            res.result.inspectionRouteVOList.forEach(item=>{
              routeIds.push(item.id);
            });
            params.routeIds = routeIds;
            postAction(this.url.edit,params).then(res=>{
              if(res.success){
                this.$message.success(message);
                this.loading = false;
                this.loadData();
              }else{
                this.$message.success(message);
                this.loading = true;
              }
            });
          }
        });
      },
      // 上面选择
      onSelectChange(selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys;
        if (this.selectedRowKeys.length == 0) {
          this.dataSource1 = []
          return;
        }
        getAction(this.url.queryTableById,{id:selectedRowKeys[0]}).then(res=>{
          if(res.success){
            this.dataSource1 = res.result;
          }
        })
      },
      customRow (record, index) {
        return {
          on:{
            click:(e)=>{
              this.selectedRowKeys = [e.currentTarget.dataset.rowKey];
              getAction(this.url.queryTableById,{id:e.currentTarget.dataset.rowKey}).then(res=>{
                if(res.success){
                  this.dataSource1 = res.result;
                }
              })
            }
          }
        }
      },
      handleDetail1(row){
        this.$refs.deviceForm.edit({...row,id:row.deviceId});
        this.$refs.deviceForm.title = this.$t('详情');
        this.$refs.deviceForm.disableSubmit = true;
      },
      handleTableChange(pagination, filters, sorter) {
        //分页、排序、筛选变化时触发
        //TODO 筛选
        if (Object.keys(sorter).length > 0) {
          this.isorter.column = sorter.field;
          this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
        }
        this.ipagination = pagination;
        this.loadData();
        this.selectedRowKeys = [];
        this.dataSource1 = [];
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
  /deep/ .ant-table-thead{
    position: sticky;
    top: 0;
    z-index: 1;
  }
  /deep/ .ant-table-body{
    overflow-y: scroll;
    max-height: 450px;
  }
</style>